 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account-page~brand-page~category-page~change-password~checkout-page~collection-page~default-layout~f~eb1fc730":"account-page~brand-page~category-page~change-password~checkout-page~collection-page~default-layout~f~eb1fc730","account-page~brand-page~category-page~collection-page~default-layout~home-page~lightning-page~navbar~538feb7b":"account-page~brand-page~category-page~collection-page~default-layout~home-page~lightning-page~navbar~538feb7b","account-page~change-password~checkout-page~set-password":"account-page~change-password~checkout-page~set-password","account-page~checkout-page":"account-page~checkout-page","account-page":"account-page","brand-page~category-page~checkout-page~collection-page~default-layout~home-page~navbar-layout~order-~3cb28ed5":"brand-page~category-page~checkout-page~collection-page~default-layout~home-page~navbar-layout~order-~3cb28ed5","brand-page~category-page~collection-page~default-layout~home-page~navbar-layout~product-page~search-~70860457":"brand-page~category-page~collection-page~default-layout~home-page~navbar-layout~product-page~search-~70860457","brand-page":"brand-page","category-page":"category-page","collection-page":"collection-page","default-layout":"default-layout","home-page":"home-page","navbar-layout":"navbar-layout","search-page":"search-page","trending-page":"trending-page","change-password":"change-password","set-password":"set-password","checkout-page":"checkout-page","order-details-page":"order-details-page","forgot-password":"forgot-password","invoice":"invoice","login-page":"login-page","packing-list":"packing-list","lightning-page~product-page":"lightning-page~product-page","product-page":"product-page","watchlist-page":"watchlist-page","lightning-page":"lightning-page","categories-page":"categories-page","checkout-layout":"checkout-layout","error-404":"error-404","invoices-download":"invoices-download","invoiceui":"invoiceui","privacy-policy":"privacy-policy","terms-and-conditions":"terms-and-conditions"}[chunkId]||chunkId) + "." + {"account-page~brand-page~category-page~change-password~checkout-page~collection-page~default-layout~f~eb1fc730":"3847f256","account-page~brand-page~category-page~collection-page~default-layout~home-page~lightning-page~navbar~538feb7b":"033accda","account-page~change-password~checkout-page~set-password":"c6dde499","account-page~checkout-page":"10d23dbc","account-page":"1f5f5397","brand-page~category-page~checkout-page~collection-page~default-layout~home-page~navbar-layout~order-~3cb28ed5":"9ed735ae","brand-page~category-page~collection-page~default-layout~home-page~navbar-layout~product-page~search-~70860457":"9f84c0dc","brand-page":"32c250b8","category-page":"1b31cae0","collection-page":"044a7de3","default-layout":"06a83510","home-page":"c68fbd6a","navbar-layout":"22f6fee8","search-page":"b3ffa68e","trending-page":"20398847","change-password":"f6ba0300","set-password":"5975624d","checkout-page":"2b70fc89","order-details-page":"5ab8c306","forgot-password":"959c869a","invoice":"6d056a0b","login-page":"c76cd99c","packing-list":"0cc7f841","lightning-page~product-page":"ba23ce64","product-page":"a49742e9","watchlist-page":"d639133c","lightning-page":"f927626e","categories-page":"aa686b76","checkout-layout":"6b00a690","error-404":"460e2f3a","invoices-download":"7a557459","invoiceui":"e0178dd7","privacy-policy":"46499f2f","terms-and-conditions":"039791fc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account-page~checkout-page":1,"account-page":1,"brand-page":1,"category-page":1,"collection-page":1,"default-layout":1,"home-page":1,"navbar-layout":1,"search-page":1,"trending-page":1,"checkout-page":1,"order-details-page":1,"forgot-password":1,"invoice":1,"packing-list":1,"lightning-page~product-page":1,"product-page":1,"watchlist-page":1,"lightning-page":1,"categories-page":1,"checkout-layout":1,"error-404":1,"invoices-download":1,"invoiceui":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account-page~brand-page~category-page~change-password~checkout-page~collection-page~default-layout~f~eb1fc730":"account-page~brand-page~category-page~change-password~checkout-page~collection-page~default-layout~f~eb1fc730","account-page~brand-page~category-page~collection-page~default-layout~home-page~lightning-page~navbar~538feb7b":"account-page~brand-page~category-page~collection-page~default-layout~home-page~lightning-page~navbar~538feb7b","account-page~change-password~checkout-page~set-password":"account-page~change-password~checkout-page~set-password","account-page~checkout-page":"account-page~checkout-page","account-page":"account-page","brand-page~category-page~checkout-page~collection-page~default-layout~home-page~navbar-layout~order-~3cb28ed5":"brand-page~category-page~checkout-page~collection-page~default-layout~home-page~navbar-layout~order-~3cb28ed5","brand-page~category-page~collection-page~default-layout~home-page~navbar-layout~product-page~search-~70860457":"brand-page~category-page~collection-page~default-layout~home-page~navbar-layout~product-page~search-~70860457","brand-page":"brand-page","category-page":"category-page","collection-page":"collection-page","default-layout":"default-layout","home-page":"home-page","navbar-layout":"navbar-layout","search-page":"search-page","trending-page":"trending-page","change-password":"change-password","set-password":"set-password","checkout-page":"checkout-page","order-details-page":"order-details-page","forgot-password":"forgot-password","invoice":"invoice","login-page":"login-page","packing-list":"packing-list","lightning-page~product-page":"lightning-page~product-page","product-page":"product-page","watchlist-page":"watchlist-page","lightning-page":"lightning-page","categories-page":"categories-page","checkout-layout":"checkout-layout","error-404":"error-404","invoices-download":"invoices-download","invoiceui":"invoiceui","privacy-policy":"privacy-policy","terms-and-conditions":"terms-and-conditions"}[chunkId]||chunkId) + "." + {"account-page~brand-page~category-page~change-password~checkout-page~collection-page~default-layout~f~eb1fc730":"31d6cfe0","account-page~brand-page~category-page~collection-page~default-layout~home-page~lightning-page~navbar~538feb7b":"31d6cfe0","account-page~change-password~checkout-page~set-password":"31d6cfe0","account-page~checkout-page":"7ff3703d","account-page":"7ccd74a1","brand-page~category-page~checkout-page~collection-page~default-layout~home-page~navbar-layout~order-~3cb28ed5":"31d6cfe0","brand-page~category-page~collection-page~default-layout~home-page~navbar-layout~product-page~search-~70860457":"31d6cfe0","brand-page":"06b0aebc","category-page":"5cd06e66","collection-page":"1352f790","default-layout":"4bc8403e","home-page":"f7fc7305","navbar-layout":"b13e2406","search-page":"17d18b8e","trending-page":"4c6cacc5","change-password":"31d6cfe0","set-password":"31d6cfe0","checkout-page":"601f4e8a","order-details-page":"9569e4ec","forgot-password":"1d43f3bf","invoice":"f9b7ef09","login-page":"31d6cfe0","packing-list":"737f4871","lightning-page~product-page":"7e7babd5","product-page":"b2e22726","watchlist-page":"d5a6c91c","lightning-page":"2803b737","categories-page":"9c3a57eb","checkout-layout":"32d9fc68","error-404":"b04f124d","invoices-download":"0e7c316f","invoiceui":"513be8b5","privacy-policy":"31d6cfe0","terms-and-conditions":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
